import { lato, nunito_sans } from '@styles/fonts'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    marginBottom: '150px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '100px',
    },
  },
  leftSectionContainer: {
    width: '100%',
    height: '443.46px',
    borderRadius: '20px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      height: '223.41px',
    },
  },
  leftSectionZenContainer: {
    border: '1px solid black',
  },
  imgCaptionContainer: {
    alignSelf: 'flex-end',
    width: '100%',
    color: 'white',
    padding: '42px',
    [theme.breakpoints.down('sm')]: {
      padding: '18px',
    },
  },
  imgCaptionZenContainer: {
    color: 'black',
  },
  imgContainer: {
    position: 'relative',
    width: '67px',
    height: '67px',
    borderRadius: '50%',
    marginRight: '12px',
    [theme.breakpoints.down('sm')]: {
      width: '33.75px',
      height: '33.75px',
    },
  },
  logoText: {
    fontFamily: nunito_sans.style.fontFamily,
    fontWeight: '700',
    lineHeight: '21.82px',
    fontSize: '16px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '19px',
    },
  },
  logoPara: {
    marginTop: '10px',
    fontFamily: nunito_sans.style.fontFamily,
    fontWeight: '800',
    lineHeight: '34px',
    fontSize: '24px',
    textTransform: 'uppercase',
    width: '95%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
  rightSectionContainer: {
    width: '90%',
  },
  rightHeading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontWeight: '800',
    lineHeight: '58px',
    fontSize: '48px',
    textTransform: 'uppercase',
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '6px',
      fontSize: '34px',
      lineHeight: '50px',
    },
  },
  rightSubHeading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontWeight: '800',
    lineHeight: '28px',
    fontSize: '24px',
    textTransform: 'uppercase',
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '8px',
      fontSize: '18px',
      lineHeight: '28px',
    },
  },
  rightPara: {
    fontFamily: lato.style.fontFamily,
    fontWeight: '400',
    lineHeight: '24px',
    fontSize: '20px',
    opacity: 0.7,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '17px',
      marginBottom: '26px',
    },
  },
}))

export default useStyles
